angular.
module("dx.webapp.clientVersion").
factory("DxClientVersion", function ClientVersionService(
	dxDateUtils
) {
	"use strict";

	return function ClientVersion(initial) {
		if (!(this instanceof ClientVersion)) {
			throw new Error("Constructor must be called with 'new'.");
		}

		angular.extend(this, {
			buildKey: "",
			created: null,
			deleted: false,
			deprecationTime: null,
			id: 0,
			modified: null,
			platform: "",
			versionNumber: "",
			architecture: "",
		});

		if (initial) {
			angular.extend(this, initial);

			this.created = dxDateUtils.getDateIfValid(this.created);
			this.deprecationTime = dxDateUtils.getDateIfValid(this.deprecationTime);
			this.modified = dxDateUtils.getDateIfValid(this.modified);
			this.deprecationTimeIsSet = !!this.deprecationTime;
		}
	};
});
